import { Outlet, type RouteObject } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import type { RouteHandle } from '@/layout/routeHandle';
import { EquipmentDetailPage } from './EquipmentDetailPage';
import { EquipmentFormPage } from './EquipmentFormPage';
import { EquipmentListPage } from './EquipmentListPage';

/** 機器管理（S-80, S-81）。基金：登録・編集／漁協：自組織の参照。パスは `/years/:year` からの相対 */
export const routes: RouteObject[] = [
  {
    path: 'equipment',
    handle: { crumb: '機器管理' } satisfies RouteHandle,
    element: (
      <RequireAuth roles={['基金', '漁協']}>
        <Outlet />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <EquipmentListPage /> },
      { path: 'new', element: <EquipmentFormPage />, handle: { crumb: '新規登録' } satisfies RouteHandle },
      { path: ':id', element: <EquipmentDetailPage />, handle: { crumb: '詳細' } satisfies RouteHandle },
      { path: ':id/edit', element: <EquipmentFormPage />, handle: { crumb: '編集' } satisfies RouteHandle },
    ],
  },
];
